import { makeStyles } from '@material-ui/core/styles';

export const styles = makeStyles({
  userImage: {
    background: 'rgb(52, 56, 65)',
    color: '#fff',
    borderRadius: '50%',
    maxWidth: '100%',
    maxHeight: '100%',
    textAlign: 'center',
    cursor: 'pointer',
  },
  displayCountImage: {
    backgroundColor: 'rgb(119, 120, 125) !important',
    // backgroundColor: 'orange !important'
  },
});
